module.exports = __webpack_public_path__ + "img/journeyinsights.a87e5d56.png";